import { render, staticRenderFns } from "./bottomTool.vue?vue&type=template&id=19551646&scoped=true"
import script from "./bottomTool.vue?vue&type=script&lang=js"
export * from "./bottomTool.vue?vue&type=script&lang=js"
import style0 from "./bottomTool.vue?vue&type=style&index=0&id=19551646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19551646",
  null
  
)

export default component.exports